import { useMemo } from 'react';

import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

const SPECIAL_WARNING_STATES_CODES = [
  'AZ',
  'CA',
  'ID',
  'LA',
  'NV',
  'NM',
  'TX',
  'WA',
  'WI',
];

const useHasWarningAddressState = () => {
  const { employee } = useEmployeeStore();
  const hasWarningState = useMemo(() => {
    const employeeAddressStateCode = employee?.addresses
      ?.find((address) => address?.preferredPhysical)?.state;
    return SPECIAL_WARNING_STATES_CODES.some((code) => code === employeeAddressStateCode);
  }, [employee]);

  return hasWarningState;
};

export default useHasWarningAddressState;
